import React from "react";
import PropTypes from "prop-types";

/**
 * api_request component 多字段渲染器。完全 schema 驱动:
 * - fields[i].type === "select" → 渲染 <select>,选项来自 fields[i].options
 * - fields[i].type === "input"  → 渲染 <input>,monospace=true 时套等宽字体
 * - fields[i].name 为空时:不显示标签,但控件照常渲染
 *
 * 数据源:componentData[component.name],通过 values prop 传入。
 * 写入:onChange(key, value) → 由 PropertyPanel 包装为 onComponentValueChange。
 */
function ApiRequestLine({ fields, values, isEdit = true, onChange }) {
  if (!fields || fields.length === 0) return null;
  return (
    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
      {fields.map((f) => {
        const current = values?.[f.key] ?? "";
        if (f.type === "select") {
          const colorFor = (v) =>
            f.options?.find((o) => o.value === v)?.color || "#2563eb";
          return (
            <select
              key={f.key}
              className="tfe-form-control"
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                color: colorFor(current),
              }}
              value={current}
              disabled={!isEdit}
              onChange={(e) => onChange(f.key, e.target.value)}
            >
              {(f.options || []).map((o) => (
                <option key={o.value} value={o.value}>{o.name}</option>
              ))}
            </select>
          );
        }
        return (
          <input
            key={f.key}
            className="tfe-form-control"
            style={f.monospace ? { fontFamily: "monospace", fontSize: "15px" } : undefined}
            value={current}
            placeholder={f.placeholder || ""}
            readOnly={!isEdit}
            onChange={(e) => onChange(f.key, e.target.value)}
          />
        );
      })}
    </div>
  );
}

ApiRequestLine.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string,
      type: PropTypes.oneOf(["input", "textarea", "select"]).isRequired,
      options: PropTypes.array,
      placeholder: PropTypes.string,
      monospace: PropTypes.bool,
    })
  ),
  values: PropTypes.object,
  isEdit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default ApiRequestLine;
